/* Little Label cart sync (2026-10-21).
   Loaded on every page (announcement-bar custom liquid).

   Why: the Little Bloom mix & match automatic discounts re-key every cart line whenever the cart
   changes. The theme's drawer stores line keys in its markup, so any add that bypasses the theme's
   CartApi (homepage carousel, quick-adds, third-party widgets) leaves the drawer and header count
   stale, and the next remove / quantity change targets a key that no longer exists -> nothing happens.

   Fix:
   1. Watch every cart mutation (fetch + XHR to /cart/add|change|update|clear). If the theme didn't
      emit its own "cart:updated" for it, refresh the drawer + header count via themeCore.CartApi.
   2. Remove (bin) buttons: resolve the line's CURRENT key from /cart.js before removing, so a stale
      key can never make remove silently fail.
   3. Quantity +/- : same key refresh before the theme sends its request.
   4. Refresh when the drawer opens, so it never shows stale contents. */
(function () {
  if (window.__llCartSync) return;
  window.__llCartSync = true;

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var lastThemeUpdate = 0;
  var refreshTimer = null;
  var refreshing = false;

  function api() {
    return window.themeCore && window.themeCore.CartApi && window.themeCore.EventBus ? window.themeCore : null;
  }

  // open=true lets the theme show its normal "added" feedback (opens the drawer), used after
  // adds that bypassed the theme (e.g. quick-add carousels).
  function refresh(open) {
    var tc = api();
    if (!tc || refreshing) return Promise.resolve();
    refreshing = true;
    return tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART, open === true ? {} : { noOpen: true })
      .catch(function () {})
      .then(function () {
        refreshing = false;
        // GET_CART updates count/notes; 'cart:refresh' makes the theme re-render the drawer line items.
        var t = api();
        if (t) t.EventBus.emit('cart:refresh');
      });
  }

  var pendingOpen = false;
  function scheduleRefresh(open) {
    var requestedAt = Date.now();
    if (open === true) pendingOpen = true;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      var doOpen = pendingOpen;
      pendingOpen = false;
      if (lastThemeUpdate >= requestedAt) return; // theme already refreshed itself
      refresh(doOpen);
    }, 350);
  }

  function isMutation(url, method) {
    return (method || 'GET').toUpperCase() !== 'GET' && CART_MUTATION.test(String(url || ''));
  }

  // 1a. fetch
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || 'GET';
      var p = origFetch.apply(this, arguments);
      if (isMutation(url, method)) {
        var isAdd = /\/cart\/add/.test(String(url));
        p.then(function (res) { scheduleRefresh(isAdd && res && res.ok); }, function () { scheduleRefresh(); });
      }
      return p;
    };
  }
  // 1b. XHR
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__llCartMutation = isMutation(url, method);
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__llCartMutation) this.addEventListener('loadend', function () { scheduleRefresh(); });
    return origSend.apply(this, arguments);
  };

  function currentLine(key, index) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var exact = items.filter(function (i) { return i.key === key; })[0];
        if (exact) return exact;
        var vid = String(key || '').split(':')[0];
        var same = items.filter(function (i) { return String(i.variant_id) === vid; });
        if (same.length === 1) return same[0];
        if (same.length > 1 && index) return items[index - 1] && String(items[index - 1].variant_id) === vid ? items[index - 1] : same[0];
        return null;
      });
  }

  // 2. Remove buttons — capture phase so we run before the theme's bubble-phase handler.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-cart-item-remove');
    if (!btn) return;
    var tc = api();
    if (!tc) return; // let the plain link work as a fallback
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.__llBusy) return;
    btn.__llBusy = true;
    var row = btn.closest('[data-cart-item]');
    if (row) row.style.opacity = '0.45';
    currentLine(btn.dataset.itemKey, Number(btn.dataset.index) || 0)
      .then(function (line) {
        if (!line) return refresh();
        return tc.CartApi.makeRequest(tc.CartApi.actions.REMOVE_CART_ITEM, line.key)
          .catch(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: String(line.variant_id), quantity: 0 })
            }).then(refresh);
          });
      })
      .catch(refresh)
      .then(function () {
        var t = api();
        if (t) t.EventBus.emit('cart:refresh');
        btn.__llBusy = false;
        if (row) row.style.opacity = '';
      });
  }, true);

  // 3. Quantity widgets: before the theme reads the key, make sure the row carries the current key.
  function freshenKeys() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byVariant = {};
        (cart.items || []).forEach(function (i) { (byVariant[i.variant_id] = byVariant[i.variant_id] || []).push(i.key); });
        document.querySelectorAll('[data-item-key], [data-key]').forEach(function (el) {
          var attr = el.hasAttribute('data-item-key') ? 'data-item-key' : 'data-key';
          var k = el.getAttribute(attr);
          if (!k || k.indexOf(':') < 0) return;
          var keys = byVariant[k.split(':')[0]];
          if (keys && keys.length === 1 && keys[0] !== k) el.setAttribute(attr, keys[0]);
        });
      })
      .catch(function () {});
  }

  function boot() {
    var tc = api();
    if (!tc) { setTimeout(boot, 250); return; }
    if (boot.done) return;
    boot.done = true;
    tc.EventBus.listen('cart:updated', function () { lastThemeUpdate = Date.now(); });
    // 4. Fresh drawer whenever it opens.
    tc.EventBus.listen('cart:drawer:open', function () { freshenKeys(); });
    // Keys can go stale if the shopper added something in another tab; freshen when they come back.
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('theme:all:loaded', boot);
})();
